import { AutogenModelCarrierScorecard, AutogenRowCarrierScorecard } from "./autogen/AutogenModelCarrierScorecard";

export class ModelCarrierScorecard extends AutogenModelCarrierScorecard<RowCarrierScorecard> {
	constructor() {
		super(RowCarrierScorecard);
	}
}

export class RowCarrierScorecard extends AutogenRowCarrierScorecard {
}